import {
  Button,
  CircularProgress,
  FormControl,
  Box,
  OutlinedInput,
  styled,
} from "@mui/material";
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import UserContext from "../../contexts/user";
import { useSnackbar } from "notistack";
import routes from "../../constants/routes";
import roleRoutes from "../../constants/roleRoutes";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";

const StyledFormControl = styled(FormControl)({
  borderRadius: "0.5rem",
  height: "3rem",
  width: "21rem",
  background: "#EEF6FF",
  border: "1px solid #5865F2",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "transparent",
    },
    "&:hover fieldset": {
      borderColor: "transparent",
    },
    "&.Mui-focused fieldset": {
      borderColor: "transparent",
    },
  },
  "& .MuiOutlinedInput-input": {
    display: "flex",
    alignItems: "center",
    color: "#6A6A6A",
    padding: "4px",
    background: "transparent",
  },
});

const StyledButton = styled(Button)({
  backgroundColor: "#5865F2",
  height: "3rem",
  width: "21rem",
  borderRadius: "1.5rem",
  color: "#FFFFFF",
  letterSpacing: "0.078125rem",
});

const Reset = () => {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const { enqueueSnackbar } = useSnackbar();
  const [formData, setFormData] = useState({
    email: "",
    code: "",
    newPassword: "",
    confirmPassword: "",
  });
  const { user, setUser, userRole, setUserRole } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [verificationCodeSent, setVerificationCodeSent] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const sendVerificationCode = async () => {
    setLoading(true);
    try {
      const { email } = formData;
      await Auth.forgotPassword(email);
      setLoading(false);
      setVerificationCodeSent(true);
    } catch (e) {
      console.log("Reset Password: Error", e);
      enqueueSnackbar("Incorrect username", { variant: "error" });
      setLoading(false);
    }
  };

  const resetPassword = async () => {
    setLoading(true);
    try {
      const { email, code, newPassword, confirmPassword } = formData;
      if (newPassword !== confirmPassword) {
        console.log("Reset Password: Error");
        enqueueSnackbar("Passwords do not match!", { variant: "error" });
        setLoading(false);
      } else {
        await Auth.forgotPasswordSubmit(email, code, newPassword);
        setLoading(false);
        navigate("/");
      }
    } catch (e) {
      console.log("Reset Password: Error", e);
      enqueueSnackbar(e.message, { variant: "error" });
      setLoading(false);
    }
  };
  return (
    <>
      {verificationCodeSent ? (
        <>
          <StyledFormControl>
            <OutlinedInput
              placeholder="Verification Code"
              type="number"
              name="code"
              value={formData.code}
              onChange={handleChange}
            />
          </StyledFormControl>
          <StyledFormControl>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <LockIcon
                sx={{
                  height: "1.5rem",
                  width: "1rem",
                  marginLeft: "1rem",
                  color: "#5865F2",
                }}
              />
              <OutlinedInput
                type={showPassword ? "text" : "password"}
                placeholder="New Password"
                sx={{
                  flex: 1,
                }}
                name="newPassword"
                value={formData.newPassword}
                onChange={handleChange}
              />
              <VisibilityIcon
                onClick={handleTogglePassword}
                sx={{
                  height: "1.5rem",
                  width: "1.3125rem",
                  marginRight: "1.125rem",
                  color: "#5865F2",
                  cursor: "pointer",
                }}
              />
            </Box>
          </StyledFormControl>
          <StyledFormControl>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <LockIcon
                sx={{
                  height: "1.5rem",
                  width: "1rem",
                  marginLeft: "1rem",
                  color: "#5865F2",
                }}
              />
              <OutlinedInput
                type={showPassword ? "text" : "password"}
                placeholder="Confirm Password"
                sx={{
                  flex: 1,
                }}
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
              />
              <VisibilityIcon
                onClick={handleTogglePassword}
                sx={{
                  height: "1.5rem",
                  width: "1.3125rem",
                  marginRight: "1.125rem",
                  color: "#5865F2",
                  cursor: "pointer",
                }}
              />
            </Box>
          </StyledFormControl>
        </>
      ) : (
        <>
          <StyledFormControl>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <EmailIcon
                sx={{
                  height: "1.5rem",
                  width: "1.125rem",
                  marginLeft: "0.9375rem",
                  color: "#5865F2",
                }}
              />
              <OutlinedInput
                placeholder="abcd@gmail.com"
                sx={{
                  flex: 1,
                }}
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </Box>
          </StyledFormControl>
        </>
      )}

      <StyledButton
        onClick={verificationCodeSent ? resetPassword : sendVerificationCode}
        sx={{ mt: 1 }}
        variant="contained"
      >
        {loading ? (
          <CircularProgress size={"1.4rem"} color="inherit" />
        ) : verificationCodeSent ? (
          "Reset Password"
        ) : (
          "NEXT"
        )}
      </StyledButton>
    </>
  );
};

export default Reset;
